import styled from 'styled-components'
import { colors } from '~/styles/colors'

export const FundraiserWrapper = styled.a({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  padding: '18px 30px',
  margin: '-1px -30px 0',

  '::after': {
    content: "''",
    position: 'absolute',
    height: 1,
    left: 112,
    right: 30,
    bottom: 0,
    background: colors.whiteFog,
  },

  '&:hover': {
    background: colors.soft,
    borderRadius: 2,

    '::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: colors.border,
      borderRadius: 2,
      background: 'none',
    },
  },
})
